(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
    Copyright 2018  Alfredo Mungo <alfredo.mungo@protonmail.ch>

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
*/ if (!Object.fromEntries) Object.defineProperty(Object, "fromEntries", {
    value (entries) {
        if (!entries || !entries[Symbol.iterator]) throw new Error("Object.fromEntries() requires a single iterable argument");
        const o = {};
        Object.keys(entries).forEach((key)=>{
            const [k, v] = entries[key];
            o[k] = v;
        });
        return o;
    }
});


/**
 * WordPress dependencies
 */ /**
 * External dependencies
 */ /**
 * Memize options object.
 *
 * @typedef MemizeOptions
 *
 * @property {number} [maxSize] Maximum size of the cache.
 */ /**
 * Internal cache entry.
 *
 * @typedef MemizeCacheNode
 *
 * @property {?MemizeCacheNode|undefined} [prev] Previous node.
 * @property {?MemizeCacheNode|undefined} [next] Next node.
 * @property {Array<*>}                   args   Function arguments for cache
 *                                               entry.
 * @property {*}                          val    Function result.
 */ /**
 * Properties of the enhanced function for controlling cache.
 *
 * @typedef MemizeMemoizedFunction
 *
 * @property {()=>void} clear Clear the cache.
 */ /**
 * Accepts a function to be memoized, and returns a new memoized function, with
 * optional options.
 *
 * @template {(...args: any[]) => any} F
 *
 * @param {F}             fn        Function to memoize.
 * @param {MemizeOptions} [options] Options object.
 *
 * @return {((...args: Parameters<F>) => ReturnType<F>) & MemizeMemoizedFunction} Memoized function.
 */ function $9b07a4a2ec57ba68$export$2e2bcd8739ae039(fn, options) {
    var size = 0;
    /** @type {?MemizeCacheNode|undefined} */ var head;
    /** @type {?MemizeCacheNode|undefined} */ var tail;
    options = options || {};
    function memoized() {
        var node = head, len = arguments.length, args, i;
        searchCache: while(node){
            // Perform a shallow equality test to confirm that whether the node
            // under test is a candidate for the arguments passed. Two arrays
            // are shallowly equal if their length matches and each entry is
            // strictly equal between the two sets. Avoid abstracting to a
            // function which could incur an arguments leaking deoptimization.
            // Check whether node arguments match arguments length
            if (node.args.length !== arguments.length) {
                node = node.next;
                continue;
            }
            // Check whether node arguments match arguments values
            for(i = 0; i < len; i++)if (node.args[i] !== arguments[i]) {
                node = node.next;
                continue searchCache;
            }
            // At this point we can assume we've found a match
            // Surface matched node to head if not already
            if (node !== head) {
                // As tail, shift to previous. Must only shift if not also
                // head, since if both head and tail, there is no previous.
                if (node === tail) tail = node.prev;
                // Adjust siblings to point to each other. If node was tail,
                // this also handles new tail's empty `next` assignment.
                /** @type {MemizeCacheNode} */ node.prev.next = node.next;
                if (node.next) node.next.prev = node.prev;
                node.next = head;
                node.prev = null;
                /** @type {MemizeCacheNode} */ head.prev = node;
                head = node;
            }
            // Return immediately
            return node.val;
        }
        // No cached value found. Continue to insertion phase:
        // Create a copy of arguments (avoid leaking deoptimization)
        args = new Array(len);
        for(i = 0; i < len; i++)args[i] = arguments[i];
        node = {
            args: args,
            // Generate the result from original function
            val: fn.apply(null, args)
        };
        // Don't need to check whether node is already head, since it would
        // have been returned above already if it was
        // Shift existing head down list
        if (head) {
            head.prev = node;
            node.next = head;
        } else // If no head, follows that there's no tail (at initial or reset)
        tail = node;
        // Trim tail if we're reached max size and are pending cache insertion
        if (size === /** @type {MemizeOptions} */ options.maxSize) {
            tail = /** @type {MemizeCacheNode} */ tail.prev;
            /** @type {MemizeCacheNode} */ tail.next = null;
        } else size++;
        head = node;
        return node.val;
    }
    memoized.clear = function() {
        head = null;
        tail = null;
        size = 0;
    };
    // Ignore reason: There's not a clear solution to create an intersection of
    // the function with additional properties, where the goal is to retain the
    // function signature of the incoming argument and add control properties
    // on the return value.
    // @ts-ignore
    return memoized;
}


var $4d9693e23ee0dc1e$exports = {};

$parcel$export($4d9693e23ee0dc1e$exports, "sprintf", function () { return $4d9693e23ee0dc1e$export$63151d8bb18a49f9; }, function (v) { return $4d9693e23ee0dc1e$export$63151d8bb18a49f9 = v; });
$parcel$export($4d9693e23ee0dc1e$exports, "vsprintf", function () { return $4d9693e23ee0dc1e$export$790fb69b1a2884f9; }, function (v) { return $4d9693e23ee0dc1e$export$790fb69b1a2884f9 = v; });
/* global window, exports, define */ var $4d9693e23ee0dc1e$export$63151d8bb18a49f9;
var $4d9693e23ee0dc1e$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $4d9693e23ee0dc1e$export$63151d8bb18a49f9 = sprintf;
    $4d9693e23ee0dc1e$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line


/**
 * Log to console, once per message; or more precisely, per referentially equal
 * argument set. Because Jed throws errors, we log these to the console instead
 * to avoid crashing the application.
 *
 * @param {...*} args Arguments to pass to `console.error`
 */ const $c1955588bc325b20$var$logErrorOnce = (0, $9b07a4a2ec57ba68$export$2e2bcd8739ae039)(console.error); // eslint-disable-line no-console
function $c1955588bc325b20$export$63151d8bb18a49f9(format, ...args) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4d9693e23ee0dc1e$exports))).sprintf(format, ...args);
    } catch (error) {
        if (error instanceof Error) $c1955588bc325b20$var$logErrorOnce("sprintf error: \n\n" + error.toString());
        return format;
    }
}


/**
 * External dependencies
 */ var $2481d2a2099dfad2$var$PRECEDENCE, $2481d2a2099dfad2$var$OPENERS, $2481d2a2099dfad2$var$TERMINATORS, $2481d2a2099dfad2$var$PATTERN;
/**
 * Operator precedence mapping.
 *
 * @type {Object}
 */ $2481d2a2099dfad2$var$PRECEDENCE = {
    "(": 9,
    "!": 8,
    "*": 7,
    "/": 7,
    "%": 7,
    "+": 6,
    "-": 6,
    "<": 5,
    "<=": 5,
    ">": 5,
    ">=": 5,
    "==": 4,
    "!=": 4,
    "&&": 3,
    "||": 2,
    "?": 1,
    "?:": 1
};
/**
 * Characters which signal pair opening, to be terminated by terminators.
 *
 * @type {string[]}
 */ $2481d2a2099dfad2$var$OPENERS = [
    "(",
    "?"
];
/**
 * Characters which signal pair termination, the value an array with the
 * opener as its first member. The second member is an optional operator
 * replacement to push to the stack.
 *
 * @type {string[]}
 */ $2481d2a2099dfad2$var$TERMINATORS = {
    ")": [
        "("
    ],
    ":": [
        "?",
        "?:"
    ]
};
/**
 * Pattern matching operators and openers.
 *
 * @type {RegExp}
 */ $2481d2a2099dfad2$var$PATTERN = /<=|>=|==|!=|&&|\|\||\?:|\(|!|\*|\/|%|\+|-|<|>|\?|\)|:/;
function $2481d2a2099dfad2$export$2e2bcd8739ae039(expression) {
    var terms = [], stack = [], match, operator, term, element;
    while(match = expression.match($2481d2a2099dfad2$var$PATTERN)){
        operator = match[0];
        // Term is the string preceding the operator match. It may contain
        // whitespace, and may be empty (if operator is at beginning).
        term = expression.substr(0, match.index).trim();
        if (term) terms.push(term);
        while(element = stack.pop()){
            if ($2481d2a2099dfad2$var$TERMINATORS[operator]) {
                if ($2481d2a2099dfad2$var$TERMINATORS[operator][0] === element) {
                    // Substitution works here under assumption that because
                    // the assigned operator will no longer be a terminator, it
                    // will be pushed to the stack during the condition below.
                    operator = $2481d2a2099dfad2$var$TERMINATORS[operator][1] || operator;
                    break;
                }
            } else if ($2481d2a2099dfad2$var$OPENERS.indexOf(element) >= 0 || $2481d2a2099dfad2$var$PRECEDENCE[element] < $2481d2a2099dfad2$var$PRECEDENCE[operator]) {
                // Push to stack if either an opener or when pop reveals an
                // element of lower precedence.
                stack.push(element);
                break;
            }
            // For each popped from stack, push to terms.
            terms.push(element);
        }
        if (!$2481d2a2099dfad2$var$TERMINATORS[operator]) stack.push(operator);
        // Slice matched fragment from expression to continue match.
        expression = expression.substr(match.index + operator.length);
    }
    // Push remainder of operand, if exists, to terms.
    expression = expression.trim();
    if (expression) terms.push(expression);
    // Pop remaining items from stack into terms.
    return terms.concat(stack.reverse());
}


/**
 * Operator callback functions.
 *
 * @type {Object}
 */ var $a563e0ece9c93ebb$var$OPERATORS = {
    "!": function(a) {
        return !a;
    },
    "*": function(a, b) {
        return a * b;
    },
    "/": function(a, b) {
        return a / b;
    },
    "%": function(a, b) {
        return a % b;
    },
    "+": function(a, b) {
        return a + b;
    },
    "-": function(a, b) {
        return a - b;
    },
    "<": function(a, b) {
        return a < b;
    },
    "<=": function(a, b) {
        return a <= b;
    },
    ">": function(a, b) {
        return a > b;
    },
    ">=": function(a, b) {
        return a >= b;
    },
    "==": function(a, b) {
        return a === b;
    },
    "!=": function(a, b) {
        return a !== b;
    },
    "&&": function(a, b) {
        return a && b;
    },
    "||": function(a, b) {
        return a || b;
    },
    "?:": function(a, b, c) {
        if (a) throw b;
        return c;
    }
};
function $a563e0ece9c93ebb$export$2e2bcd8739ae039(postfix, variables) {
    var stack = [], i, j, args, getOperatorResult, term, value;
    for(i = 0; i < postfix.length; i++){
        term = postfix[i];
        getOperatorResult = $a563e0ece9c93ebb$var$OPERATORS[term];
        if (getOperatorResult) {
            // Pop from stack by number of function arguments.
            j = getOperatorResult.length;
            args = Array(j);
            while(j--)args[j] = stack.pop();
            try {
                value = getOperatorResult.apply(null, args);
            } catch (earlyReturn) {
                return earlyReturn;
            }
        } else if (variables.hasOwnProperty(term)) value = variables[term];
        else value = +term;
        stack.push(value);
    }
    return stack[0];
}


function $8e3c66fdbe7b4269$export$2e2bcd8739ae039(expression) {
    var terms = (0, $2481d2a2099dfad2$export$2e2bcd8739ae039)(expression);
    return function(variables) {
        return (0, $a563e0ece9c93ebb$export$2e2bcd8739ae039)(terms, variables);
    };
}


function $14e66334a7450f89$export$2e2bcd8739ae039(expression) {
    var evaluate = (0, $8e3c66fdbe7b4269$export$2e2bcd8739ae039)(expression);
    return function(n) {
        return +evaluate({
            n: n
        });
    };
}


/**
 * Tannin constructor options.
 *
 * @typedef {Object} TanninOptions
 *
 * @property {string}   [contextDelimiter] Joiner in string lookup with context.
 * @property {Function} [onMissingKey]     Callback to invoke when key missing.
 */ /**
 * Domain metadata.
 *
 * @typedef {Object} TanninDomainMetadata
 *
 * @property {string}            [domain]       Domain name.
 * @property {string}            [lang]         Language code.
 * @property {(string|Function)} [plural_forms] Plural forms expression or
 *                                              function evaluator.
 */ /**
 * Domain translation pair respectively representing the singular and plural
 * translation.
 *
 * @typedef {[string,string]} TanninTranslation
 */ /**
 * Locale data domain. The key is used as reference for lookup, the value an
 * array of two string entries respectively representing the singular and plural
 * translation.
 *
 * @typedef {{[key:string]:TanninDomainMetadata|TanninTranslation,'':TanninDomainMetadata|TanninTranslation}} TanninLocaleDomain
 */ /**
 * Jed-formatted locale data.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @typedef {{[domain:string]:TanninLocaleDomain}} TanninLocaleData
 */ /**
 * Default Tannin constructor options.
 *
 * @type {TanninOptions}
 */ var $44bd981f55717c53$var$DEFAULT_OPTIONS = {
    contextDelimiter: "\x04",
    onMissingKey: null
};
/**
 * Given a specific locale data's config `plural_forms` value, returns the
 * expression.
 *
 * @example
 *
 * ```
 * getPluralExpression( 'nplurals=2; plural=(n != 1);' ) === '(n != 1)'
 * ```
 *
 * @param {string} pf Locale data plural forms.
 *
 * @return {string} Plural forms expression.
 */ function $44bd981f55717c53$var$getPluralExpression(pf) {
    var parts, i, part;
    parts = pf.split(";");
    for(i = 0; i < parts.length; i++){
        part = parts[i].trim();
        if (part.indexOf("plural=") === 0) return part.substr(7);
    }
}
function $44bd981f55717c53$export$2e2bcd8739ae039(data, options) {
    var key;
    /**
	 * Jed-formatted locale data.
	 *
	 * @name Tannin#data
	 * @type {TanninLocaleData}
	 */ this.data = data;
    /**
	 * Plural forms function cache, keyed by plural forms string.
	 *
	 * @name Tannin#pluralForms
	 * @type {Object<string,Function>}
	 */ this.pluralForms = {};
    /**
	 * Effective options for instance, including defaults.
	 *
	 * @name Tannin#options
	 * @type {TanninOptions}
	 */ this.options = {};
    for(key in $44bd981f55717c53$var$DEFAULT_OPTIONS)this.options[key] = options !== undefined && key in options ? options[key] : $44bd981f55717c53$var$DEFAULT_OPTIONS[key];
}
/**
 * Returns the plural form index for the given domain and value.
 *
 * @param {string} domain Domain on which to calculate plural form.
 * @param {number} n      Value for which plural form is to be calculated.
 *
 * @return {number} Plural form index.
 */ $44bd981f55717c53$export$2e2bcd8739ae039.prototype.getPluralForm = function(domain, n) {
    var getPluralForm = this.pluralForms[domain], config, plural, pf;
    if (!getPluralForm) {
        config = this.data[domain][""];
        pf = config["Plural-Forms"] || config["plural-forms"] || // Ignore reason: As known, there's no way to document the empty
        // string property on a key to guarantee this as metadata.
        // @ts-ignore
        config.plural_forms;
        if (typeof pf !== "function") {
            plural = $44bd981f55717c53$var$getPluralExpression(config["Plural-Forms"] || config["plural-forms"] || // Ignore reason: As known, there's no way to document the empty
            // string property on a key to guarantee this as metadata.
            // @ts-ignore
            config.plural_forms);
            pf = (0, $14e66334a7450f89$export$2e2bcd8739ae039)(plural);
        }
        getPluralForm = this.pluralForms[domain] = pf;
    }
    return getPluralForm(n);
};
/**
 * Translate a string.
 *
 * @param {string}      domain   Translation domain.
 * @param {string|void} context  Context distinguishing terms of the same name.
 * @param {string}      singular Primary key for translation lookup.
 * @param {string=}     plural   Fallback value used for non-zero plural
 *                               form index.
 * @param {number=}     n        Value to use in calculating plural form.
 *
 * @return {string} Translated string.
 */ $44bd981f55717c53$export$2e2bcd8739ae039.prototype.dcnpgettext = function(domain, context, singular, plural, n) {
    var index, key, entry;
    if (n === undefined) // Default to singular.
    index = 0;
    else // Find index by evaluating plural form for value.
    index = this.getPluralForm(domain, n);
    key = singular;
    // If provided, context is prepended to key with delimiter.
    if (context) key = context + this.options.contextDelimiter + singular;
    entry = this.data[domain][key];
    // Verify not only that entry exists, but that the intended index is within
    // range and non-empty.
    if (entry && entry[index]) return entry[index];
    if (this.options.onMissingKey) this.options.onMissingKey(singular, domain);
    // If entry not found, fall back to singular vs. plural with zero index
    // representing the singular value.
    return index === 0 ? singular : plural;
};


/**
 * @typedef {Record<string,any>} LocaleData
 */ /**
 * Default locale data to use for Tannin domain when not otherwise provided.
 * Assumes an English plural forms expression.
 *
 * @type {LocaleData}
 */ const $6c9c2b926c83970d$var$DEFAULT_LOCALE_DATA = {
    "": {
        /** @param {number} n */ plural_forms (n) {
            return n === 1 ? 0 : 1;
        }
    }
};
/*
 * Regular expression that matches i18n hooks like `i18n.gettext`, `i18n.ngettext`,
 * `i18n.gettext_domain` or `i18n.ngettext_with_context` or `i18n.has_translation`.
 */ const $6c9c2b926c83970d$var$I18N_HOOK_REGEXP = /^i18n\.(n?gettext|has_translation)(_|$)/;
const $6c9c2b926c83970d$export$920091e3d72d80ee = (initialData, initialDomain, hooks)=>{
    /**
   * The underlying instance of Tannin to which exported functions interface.
   *
   * @type {Tannin}
   */ const tannin = new (0, $44bd981f55717c53$export$2e2bcd8739ae039)({});
    const listeners = new Set();
    const notifyListeners = ()=>{
        listeners.forEach((listener)=>listener());
    };
    /**
   * Subscribe to changes of locale data.
   *
   * @param {SubscribeCallback} callback Subscription callback.
   * @return {UnsubscribeCallback} Unsubscribe callback.
   */ const subscribe = (callback)=>{
        listeners.add(callback);
        return ()=>listeners.delete(callback);
    };
    /** @type {GetLocaleData} */ const getLocaleData = (domain = "default")=>tannin.data[domain];
    /**
   * @param {LocaleData} [data]
   * @param {string}     [domain]
   */ const doSetLocaleData = (data, domain = "default")=>{
        tannin.data[domain] = {
            ...tannin.data[domain],
            ...data
        };
        // Populate default domain configuration (supported locale date which omits
        // a plural forms expression).
        tannin.data[domain][""] = {
            ...$6c9c2b926c83970d$var$DEFAULT_LOCALE_DATA[""],
            ...tannin.data[domain]?.[""]
        };
        // Clean up cached plural forms functions cache as it might be updated.
        delete tannin.pluralForms[domain];
    };
    /** @type {SetLocaleData} */ const setLocaleData = (data, domain)=>{
        doSetLocaleData(data, domain);
        notifyListeners();
    };
    /** @type {AddLocaleData} */ const addLocaleData = (data, domain = "default")=>{
        tannin.data[domain] = {
            ...tannin.data[domain],
            ...data,
            // Populate default domain configuration (supported locale date which omits
            // a plural forms expression).
            "": {
                ...$6c9c2b926c83970d$var$DEFAULT_LOCALE_DATA[""],
                ...tannin.data[domain]?.[""],
                ...data?.[""]
            }
        };
        // Clean up cached plural forms functions cache as it might be updated.
        delete tannin.pluralForms[domain];
        notifyListeners();
    };
    /** @type {ResetLocaleData} */ const resetLocaleData = (data, domain)=>{
        // Reset all current Tannin locale data.
        tannin.data = {};
        // Reset cached plural forms functions cache.
        tannin.pluralForms = {};
        setLocaleData(data, domain);
    };
    /**
   * Wrapper for Tannin's `dcnpgettext`. Populates default locale data if not
   * otherwise previously assigned.
   *
   * @param {string|undefined} domain   Domain to retrieve the translated text.
   * @param {string|undefined} context  Context information for the translators.
   * @param {string}           single   Text to translate if non-plural. Used as
   *                                    fallback return value on a caught error.
   * @param {string}           [plural] The text to be used if the number is
   *                                    plural.
   * @param {number}           [number] The number to compare against to use
   *                                    either the singular or plural form.
   *
   * @return {string} The translated string.
   */ const dcnpgettext = (domain = "default", context, single, plural, number)=>{
        if (!tannin.data[domain]) // Use `doSetLocaleData` to set silently, without notifying listeners.
        doSetLocaleData(undefined, domain);
        return tannin.dcnpgettext(domain, context, single, plural, number);
    };
    /** @type {GetFilterDomain} */ const getFilterDomain = (domain = "default")=>domain;
    /** @type {__} */ const __ = (text, domain)=>{
        let translation = dcnpgettext(domain, undefined, text);
        if (!hooks) return translation;
        /**
     * Filters text with its translation.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.gettext", translation, text, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.gettext_" + getFilterDomain(domain), translation, text, domain);
    };
    /** @type {_x} */ const _x = (text, context, domain)=>{
        let translation = dcnpgettext(domain, context, text);
        if (!hooks) return translation;
        /**
     * Filters text with its translation based on context information.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.gettext_with_context", translation, text, context, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.gettext_with_context_" + getFilterDomain(domain), translation, text, context, domain);
    };
    /** @type {_n} */ const _n = (single, plural, number, domain)=>{
        let translation = dcnpgettext(domain, undefined, single, plural, number);
        if (!hooks) return translation;
        /**
     * Filters the singular or plural form of a string.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.ngettext", translation, single, plural, number, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.ngettext_" + getFilterDomain(domain), translation, single, plural, number, domain);
    };
    /** @type {_nx} */ const _nx = (single, plural, number, context, domain)=>{
        let translation = dcnpgettext(domain, context, single, plural, number);
        if (!hooks) return translation;
        /**
     * Filters the singular or plural form of a string with gettext context.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.ngettext_with_context", translation, single, plural, number, context, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters("i18n.ngettext_with_context_" + getFilterDomain(domain), translation, single, plural, number, context, domain);
    };
    /** @type {IsRtl} */ const isRTL = ()=>{
        return "rtl" === _x("ltr", "text direction");
    };
    /** @type {HasTranslation} */ const hasTranslation = (single, context, domain)=>{
        const key = context ? context + "\x04" + single : single;
        let result = !!tannin.data?.[domain !== null && domain !== void 0 ? domain : "default"]?.[key];
        if (hooks) {
            /**
       * Filters the presence of a translation in the locale data.
       *
       * @param {boolean} hasTranslation Whether the translation is present or not..
       * @param {string}  single         The singular form of the translated text (used as key in locale data)
       * @param {string}  context        Context information for the translators.
       * @param {string}  domain         Text domain. Unique identifier for retrieving translated strings.
       */ result = /** @type { boolean } */ /** @type {*} */ hooks.applyFilters("i18n.has_translation", result, single, context, domain);
            result = /** @type { boolean } */ /** @type {*} */ hooks.applyFilters("i18n.has_translation_" + getFilterDomain(domain), result, single, context, domain);
        }
        return result;
    };
    if (initialData) setLocaleData(initialData, initialDomain);
    if (hooks) {
        /**
     * @param {string} hookName
     */ const onHookAddedOrRemoved = (hookName)=>{
            if ($6c9c2b926c83970d$var$I18N_HOOK_REGEXP.test(hookName)) notifyListeners();
        };
        hooks.addAction("hookAdded", "core/i18n", onHookAddedOrRemoved);
        hooks.addAction("hookRemoved", "core/i18n", onHookAddedOrRemoved);
    }
    return {
        getLocaleData: getLocaleData,
        setLocaleData: setLocaleData,
        addLocaleData: addLocaleData,
        resetLocaleData: resetLocaleData,
        subscribe: subscribe,
        __: __,
        _x: _x,
        _n: _n,
        _nx: _nx,
        isRTL: isRTL,
        hasTranslation: hasTranslation
    };
};


/**
 * Internal dependencies
 */ 
/**
 * Internal dependencies
 */ /**
 * Internal dependencies
 */ /**
 * Internal dependencies
 */ /**
 * Validate a namespace string.
 *
 * @param {string} namespace The namespace to validate - should take the form
 *                           `vendor/plugin/function`.
 *
 * @return {boolean} Whether the namespace is valid.
 */ function $aafdf7e1a3ab5711$var$validateNamespace(namespace) {
    if ("string" !== typeof namespace || "" === namespace) {
        // eslint-disable-next-line no-console
        console.error("The namespace must be a non-empty string.");
        return false;
    }
    if (!/^[a-zA-Z][a-zA-Z0-9_.\-\/]*$/.test(namespace)) {
        // eslint-disable-next-line no-console
        console.error("The namespace can only contain numbers, letters, dashes, periods, underscores and slashes.");
        return false;
    }
    return true;
}
var $aafdf7e1a3ab5711$export$2e2bcd8739ae039 = $aafdf7e1a3ab5711$var$validateNamespace;


/**
 * Validate a hookName string.
 *
 * @param {string} hookName The hook name to validate. Should be a non empty string containing
 *                          only numbers, letters, dashes, periods and underscores. Also,
 *                          the hook name cannot begin with `__`.
 *
 * @return {boolean} Whether the hook name is valid.
 */ function $2e2c400fba9c6ece$var$validateHookName(hookName) {
    if ("string" !== typeof hookName || "" === hookName) {
        // eslint-disable-next-line no-console
        console.error("The hook name must be a non-empty string.");
        return false;
    }
    if (/^__/.test(hookName)) {
        // eslint-disable-next-line no-console
        console.error("The hook name cannot begin with `__`.");
        return false;
    }
    if (!/^[a-zA-Z][a-zA-Z0-9_.-]*$/.test(hookName)) {
        // eslint-disable-next-line no-console
        console.error("The hook name can only contain numbers, letters, dashes, periods and underscores.");
        return false;
    }
    return true;
}
var $2e2c400fba9c6ece$export$2e2bcd8739ae039 = $2e2c400fba9c6ece$var$validateHookName;


/**
 * @callback AddHook
 *
 * Adds the hook to the appropriate hooks container.
 *
 * @param {string}               hookName      Name of hook to add
 * @param {string}               namespace     The unique namespace identifying the callback in the form `vendor/plugin/function`.
 * @param {import('.').Callback} callback      Function to call when the hook is run
 * @param {number}               [priority=10] Priority of this hook
 */ /**
 * Returns a function which, when invoked, will add a hook.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {AddHook} Function that adds a new hook.
 */ function $37036e7fc032b106$var$createAddHook(hooks, storeKey) {
    return function addHook(hookName, namespace, callback, priority = 10) {
        const hooksStore = hooks[storeKey];
        if (!(0, $2e2c400fba9c6ece$export$2e2bcd8739ae039)(hookName)) return;
        if (!(0, $aafdf7e1a3ab5711$export$2e2bcd8739ae039)(namespace)) return;
        if ("function" !== typeof callback) {
            // eslint-disable-next-line no-console
            console.error("The hook callback must be a function.");
            return;
        }
        // Validate numeric priority
        if ("number" !== typeof priority) {
            // eslint-disable-next-line no-console
            console.error("If specified, the hook priority must be a number.");
            return;
        }
        const handler = {
            callback: callback,
            priority: priority,
            namespace: namespace
        };
        if (hooksStore[hookName]) {
            // Find the correct insert index of the new hook.
            const handlers = hooksStore[hookName].handlers;
            /** @type {number} */ let i;
            for(i = handlers.length; i > 0; i--){
                if (priority >= handlers[i - 1].priority) break;
            }
            if (i === handlers.length) // If append, operate via direct assignment.
            handlers[i] = handler;
            else // Otherwise, insert before index via splice.
            handlers.splice(i, 0, handler);
            // We may also be currently executing this hook.  If the callback
            // we're adding would come after the current callback, there's no
            // problem; otherwise we need to increase the execution index of
            // any other runs by 1 to account for the added element.
            hooksStore.__current.forEach((hookInfo)=>{
                if (hookInfo.name === hookName && hookInfo.currentIndex >= i) hookInfo.currentIndex++;
            });
        } else // This is the first hook of its type.
        hooksStore[hookName] = {
            handlers: [
                handler
            ],
            runs: 0
        };
        if (hookName !== "hookAdded") hooks.doAction("hookAdded", hookName, namespace, callback, priority);
    };
}
var $37036e7fc032b106$export$2e2bcd8739ae039 = $37036e7fc032b106$var$createAddHook;


/**
 * Internal dependencies
 */ 

/**
 * @callback RemoveHook
 * Removes the specified callback (or all callbacks) from the hook with a given hookName
 * and namespace.
 *
 * @param {string} hookName  The name of the hook to modify.
 * @param {string} namespace The unique namespace identifying the callback in the
 *                           form `vendor/plugin/function`.
 *
 * @return {number | undefined} The number of callbacks removed.
 */ /**
 * Returns a function which, when invoked, will remove a specified hook or all
 * hooks by the given name.
 *
 * @param {import('.').Hooks}    hooks             Hooks instance.
 * @param {import('.').StoreKey} storeKey
 * @param {boolean}              [removeAll=false] Whether to remove all callbacks for a hookName,
 *                                                 without regard to namespace. Used to create
 *                                                 `removeAll*` functions.
 *
 * @return {RemoveHook} Function that removes hooks.
 */ function $81817062b7e433cc$var$createRemoveHook(hooks, storeKey, removeAll = false) {
    return function removeHook(hookName, namespace) {
        const hooksStore = hooks[storeKey];
        if (!(0, $2e2c400fba9c6ece$export$2e2bcd8739ae039)(hookName)) return;
        if (!removeAll && !(0, $aafdf7e1a3ab5711$export$2e2bcd8739ae039)(namespace)) return;
        // Bail if no hooks exist by this name.
        if (!hooksStore[hookName]) return 0;
        let handlersRemoved = 0;
        if (removeAll) {
            handlersRemoved = hooksStore[hookName].handlers.length;
            hooksStore[hookName] = {
                runs: hooksStore[hookName].runs,
                handlers: []
            };
        } else {
            // Try to find the specified callback to remove.
            const handlers = hooksStore[hookName].handlers;
            for(let i = handlers.length - 1; i >= 0; i--)if (handlers[i].namespace === namespace) {
                handlers.splice(i, 1);
                handlersRemoved++;
                // This callback may also be part of a hook that is
                // currently executing.  If the callback we're removing
                // comes after the current callback, there's no problem;
                // otherwise we need to decrease the execution index of any
                // other runs by 1 to account for the removed element.
                hooksStore.__current.forEach((hookInfo)=>{
                    if (hookInfo.name === hookName && hookInfo.currentIndex >= i) hookInfo.currentIndex--;
                });
            }
        }
        if (hookName !== "hookRemoved") hooks.doAction("hookRemoved", hookName, namespace);
        return handlersRemoved;
    };
}
var $81817062b7e433cc$export$2e2bcd8739ae039 = $81817062b7e433cc$var$createRemoveHook;


/**
 * @callback HasHook
 *
 * Returns whether any handlers are attached for the given hookName and optional namespace.
 *
 * @param {string} hookName    The name of the hook to check for.
 * @param {string} [namespace] Optional. The unique namespace identifying the callback
 *                             in the form `vendor/plugin/function`.
 *
 * @return {boolean} Whether there are handlers that are attached to the given hook.
 */ /**
 * Returns a function which, when invoked, will return whether any handlers are
 * attached to a particular hook.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {HasHook} Function that returns whether any handlers are
 *                   attached to a particular hook and optional namespace.
 */ function $27701b0b4b7a963a$var$createHasHook(hooks, storeKey) {
    return function hasHook(hookName, namespace) {
        const hooksStore = hooks[storeKey];
        // Use the namespace if provided.
        if ("undefined" !== typeof namespace) return hookName in hooksStore && hooksStore[hookName].handlers.some((hook)=>hook.namespace === namespace);
        return hookName in hooksStore;
    };
}
var $27701b0b4b7a963a$export$2e2bcd8739ae039 = $27701b0b4b7a963a$var$createHasHook;


/**
 * Returns a function which, when invoked, will execute all callbacks
 * registered to a hook of the specified type, optionally returning the final
 * value of the call chain.
 *
 * @param {import('.').Hooks}    hooks                  Hooks instance.
 * @param {import('.').StoreKey} storeKey
 * @param {boolean}              [returnFirstArg=false] Whether each hook callback is expected to
 *                                                      return its first argument.
 *
 * @return {(hookName:string, ...args: unknown[]) => undefined|unknown} Function that runs hook callbacks.
 */ function $9bfa151dfe090059$var$createRunHook(hooks, storeKey, returnFirstArg = false) {
    return function runHooks(hookName, ...args) {
        const hooksStore = hooks[storeKey];
        if (!hooksStore[hookName]) hooksStore[hookName] = {
            handlers: [],
            runs: 0
        };
        hooksStore[hookName].runs++;
        const handlers = hooksStore[hookName].handlers;
        if (!handlers || !handlers.length) return returnFirstArg ? args[0] : undefined;
        const hookInfo = {
            name: hookName,
            currentIndex: 0
        };
        hooksStore.__current.push(hookInfo);
        while(hookInfo.currentIndex < handlers.length){
            const handler = handlers[hookInfo.currentIndex];
            const result = handler.callback.apply(null, args);
            if (returnFirstArg) args[0] = result;
            hookInfo.currentIndex++;
        }
        hooksStore.__current.pop();
        if (returnFirstArg) return args[0];
        return undefined;
    };
}
var $9bfa151dfe090059$export$2e2bcd8739ae039 = $9bfa151dfe090059$var$createRunHook;


/**
 * Returns a function which, when invoked, will return the name of the
 * currently running hook, or `null` if no hook of the given type is currently
 * running.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {() => string | null} Function that returns the current hook name or null.
 */ function $626b0e48026e85ca$var$createCurrentHook(hooks, storeKey) {
    return function currentHook() {
        var _hooksStore$__current;
        const hooksStore = hooks[storeKey];
        return (_hooksStore$__current = hooksStore.__current[hooksStore.__current.length - 1]?.name) !== null && _hooksStore$__current !== void 0 ? _hooksStore$__current : null;
    };
}
var $626b0e48026e85ca$export$2e2bcd8739ae039 = $626b0e48026e85ca$var$createCurrentHook;


/**
 * @callback DoingHook
 * Returns whether a hook is currently being executed.
 *
 * @param {string} [hookName] The name of the hook to check for.  If
 *                            omitted, will check for any hook being executed.
 *
 * @return {boolean} Whether the hook is being executed.
 */ /**
 * Returns a function which, when invoked, will return whether a hook is
 * currently being executed.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {DoingHook} Function that returns whether a hook is currently
 *                     being executed.
 */ function $4a43405cf0d8543b$var$createDoingHook(hooks, storeKey) {
    return function doingHook(hookName) {
        const hooksStore = hooks[storeKey];
        // If the hookName was not passed, check for any current hook.
        if ("undefined" === typeof hookName) return "undefined" !== typeof hooksStore.__current[0];
        // Return the __current hook.
        return hooksStore.__current[0] ? hookName === hooksStore.__current[0].name : false;
    };
}
var $4a43405cf0d8543b$export$2e2bcd8739ae039 = $4a43405cf0d8543b$var$createDoingHook;


/**
 * Internal dependencies
 */ 
/**
 * @callback DidHook
 *
 * Returns the number of times an action has been fired.
 *
 * @param {string} hookName The hook name to check.
 *
 * @return {number | undefined} The number of times the hook has run.
 */ /**
 * Returns a function which, when invoked, will return the number of times a
 * hook has been called.
 *
 * @param {import('.').Hooks}    hooks    Hooks instance.
 * @param {import('.').StoreKey} storeKey
 *
 * @return {DidHook} Function that returns a hook's call count.
 */ function $0ac82ad33eb704ae$var$createDidHook(hooks, storeKey) {
    return function didHook(hookName) {
        const hooksStore = hooks[storeKey];
        if (!(0, $2e2c400fba9c6ece$export$2e2bcd8739ae039)(hookName)) return;
        return hooksStore[hookName] && hooksStore[hookName].runs ? hooksStore[hookName].runs : 0;
    };
}
var $0ac82ad33eb704ae$export$2e2bcd8739ae039 = $0ac82ad33eb704ae$var$createDidHook;


class $a0c4558174389b8b$export$6ab53e2237e2cbe5 {
    constructor(){
        /** @type {import('.').Store} actions */ this.actions = Object.create(null);
        this.actions.__current = [];
        /** @type {import('.').Store} filters */ this.filters = Object.create(null);
        this.filters.__current = [];
        this.addAction = (0, $37036e7fc032b106$export$2e2bcd8739ae039)(this, "actions");
        this.addFilter = (0, $37036e7fc032b106$export$2e2bcd8739ae039)(this, "filters");
        this.removeAction = (0, $81817062b7e433cc$export$2e2bcd8739ae039)(this, "actions");
        this.removeFilter = (0, $81817062b7e433cc$export$2e2bcd8739ae039)(this, "filters");
        this.hasAction = (0, $27701b0b4b7a963a$export$2e2bcd8739ae039)(this, "actions");
        this.hasFilter = (0, $27701b0b4b7a963a$export$2e2bcd8739ae039)(this, "filters");
        this.removeAllActions = (0, $81817062b7e433cc$export$2e2bcd8739ae039)(this, "actions", true);
        this.removeAllFilters = (0, $81817062b7e433cc$export$2e2bcd8739ae039)(this, "filters", true);
        this.doAction = (0, $9bfa151dfe090059$export$2e2bcd8739ae039)(this, "actions");
        this.applyFilters = (0, $9bfa151dfe090059$export$2e2bcd8739ae039)(this, "filters", true);
        this.currentAction = (0, $626b0e48026e85ca$export$2e2bcd8739ae039)(this, "actions");
        this.currentFilter = (0, $626b0e48026e85ca$export$2e2bcd8739ae039)(this, "filters");
        this.doingAction = (0, $4a43405cf0d8543b$export$2e2bcd8739ae039)(this, "actions");
        this.doingFilter = (0, $4a43405cf0d8543b$export$2e2bcd8739ae039)(this, "filters");
        this.didAction = (0, $0ac82ad33eb704ae$export$2e2bcd8739ae039)(this, "actions");
        this.didFilter = (0, $0ac82ad33eb704ae$export$2e2bcd8739ae039)(this, "filters");
    }
}
/** @typedef {_Hooks} Hooks */ /**
 * Returns an instance of the hooks object.
 *
 * @return {Hooks} A Hooks instance.
 */ function $a0c4558174389b8b$var$createHooks() {
    return new $a0c4558174389b8b$export$6ab53e2237e2cbe5();
}
var $a0c4558174389b8b$export$2e2bcd8739ae039 = $a0c4558174389b8b$var$createHooks;


const $831080c29488d110$export$3ab433d598b5afda = (0, $a0c4558174389b8b$export$2e2bcd8739ae039)();
const { addAction: $831080c29488d110$export$386cd32f765ce9e5, addFilter: $831080c29488d110$export$ae939118842f3d6d, removeAction: $831080c29488d110$export$ee23a0560a6e66e1, removeFilter: $831080c29488d110$export$3be5fe9f09d6965, hasAction: $831080c29488d110$export$e217e69099d082f5, hasFilter: $831080c29488d110$export$c529f4fe4b3e42c3, removeAllActions: $831080c29488d110$export$b6a70a7bac0324dc, removeAllFilters: $831080c29488d110$export$d2b22b11f2d9c961, doAction: $831080c29488d110$export$82b07c9aa09229f9, applyFilters: $831080c29488d110$export$47150c42ed89d097, currentAction: $831080c29488d110$export$48bb562f358e2618, currentFilter: $831080c29488d110$export$6d4307a0dba6866d, doingAction: $831080c29488d110$export$40825d7629aadbf8, doingFilter: $831080c29488d110$export$79bf63fdc44a5a89, didAction: $831080c29488d110$export$f75d20bfa140804, didFilter: $831080c29488d110$export$50fe983f23c864a8, actions: $831080c29488d110$export$e324594224ef24da, filters: $831080c29488d110$export$82462a21aead86ed } = $831080c29488d110$export$3ab433d598b5afda;


const $5b5c8d5cff038097$var$i18n = (0, $6c9c2b926c83970d$export$920091e3d72d80ee)(undefined, undefined, (0, $831080c29488d110$export$3ab433d598b5afda));
var /**
 * Default, singleton instance of `I18n`.
 */ $5b5c8d5cff038097$export$2e2bcd8739ae039 = $5b5c8d5cff038097$var$i18n;
const $5b5c8d5cff038097$export$aa5c834303254f2b = $5b5c8d5cff038097$var$i18n.getLocaleData.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$c6dc5f4bd857efee = $5b5c8d5cff038097$var$i18n.setLocaleData.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$455aeb7a226f88e0 = $5b5c8d5cff038097$var$i18n.resetLocaleData.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$ec068583843480e7 = $5b5c8d5cff038097$var$i18n.subscribe.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$c6452175cea4361a = $5b5c8d5cff038097$var$i18n.__.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$2329670d4e6fc0e6 = $5b5c8d5cff038097$var$i18n._x.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$21352aee083e072e = $5b5c8d5cff038097$var$i18n._n.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$63be10810dae5704 = $5b5c8d5cff038097$var$i18n._nx.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$702d680b21cbd764 = $5b5c8d5cff038097$var$i18n.isRTL.bind($5b5c8d5cff038097$var$i18n);
const $5b5c8d5cff038097$export$8a4bbd9646545970 = $5b5c8d5cff038097$var$i18n.hasTranslation.bind($5b5c8d5cff038097$var$i18n);




/**
 * @param {string} nonce
 * @return {import('../types').APIFetchMiddleware & { nonce: string }} A middleware to enhance a request with a nonce.
 */ function $f3a4c71ab038a960$var$createNonceMiddleware(nonce) {
    /**
   * @type {import('../types').APIFetchMiddleware & { nonce: string }}
   */ const middleware = (options, next)=>{
        const { headers: headers = {} } = options;
        // If an 'X-WP-Nonce' header (or any case-insensitive variation
        // thereof) was specified, no need to add a nonce header.
        for(const headerName in headers){
            if (headerName.toLowerCase() === "x-wp-nonce" && headers[headerName] === middleware.nonce) return next(options);
        }
        return next({
            ...options,
            headers: {
                ...headers,
                "X-WP-Nonce": middleware.nonce
            }
        });
    };
    middleware.nonce = nonce;
    return middleware;
}
var $f3a4c71ab038a960$export$2e2bcd8739ae039 = $f3a4c71ab038a960$var$createNonceMiddleware;


/**
 * Internal dependencies
 */ /**
 * @type {import('../types').APIFetchMiddleware}
 */ const $2207936dc8e96153$var$namespaceAndEndpointMiddleware = (options, next)=>{
    let path = options.path;
    let namespaceTrimmed, endpointTrimmed;
    if (typeof options.namespace === "string" && typeof options.endpoint === "string") {
        namespaceTrimmed = options.namespace.replace(/^\/|\/$/g, "");
        endpointTrimmed = options.endpoint.replace(/^\//, "");
        if (endpointTrimmed) path = namespaceTrimmed + "/" + endpointTrimmed;
        else path = namespaceTrimmed;
    }
    delete options.namespace;
    delete options.endpoint;
    return next({
        ...options,
        path: path
    });
};
var $2207936dc8e96153$export$2e2bcd8739ae039 = $2207936dc8e96153$var$namespaceAndEndpointMiddleware;


/**
 * @param {string} rootURL
 * @return {import('../types').APIFetchMiddleware} Root URL middleware.
 */ const $2a5da459ef252cbd$var$createRootURLMiddleware = (rootURL)=>(options, next)=>{
        return (0, $2207936dc8e96153$export$2e2bcd8739ae039)(options, (optionsWithPath)=>{
            let url = optionsWithPath.url;
            let path = optionsWithPath.path;
            let apiRoot;
            if (typeof path === "string") {
                apiRoot = rootURL;
                if (-1 !== rootURL.indexOf("?")) path = path.replace("?", "&");
                path = path.replace(/^\//, "");
                // API root may already include query parameter prefix if site is
                // configured to use plain permalinks.
                if ("string" === typeof apiRoot && -1 !== apiRoot.indexOf("?")) path = path.replace("?", "&");
                url = apiRoot + path;
            }
            return next({
                ...optionsWithPath,
                url: url
            });
        });
    };
var $2a5da459ef252cbd$export$2e2bcd8739ae039 = $2a5da459ef252cbd$var$createRootURLMiddleware;


/**
 * WordPress dependencies
 */ /**
 * Given a path, returns a normalized path where equal query parameter values
 * will be treated as identical, regardless of order they appear in the original
 * text.
 *
 * @param {string} path Original path.
 *
 * @return {string} Normalized path.
 */ function $aa68ca4a6d2e4cac$export$6af368f973c74c5(path) {
    const splitted = path.split("?");
    const query = splitted[1];
    const base = splitted[0];
    if (!query) return base;
    // 'b=1%2C2&c=2&a=5'
    return base + "?" + query// [ 'b=1%2C2', 'c=2', 'a=5' ]
    .split("&")// [ [ 'b, '1%2C2' ], [ 'c', '2' ], [ 'a', '5' ] ]
    .map((entry)=>entry.split("="))// [ [ 'b', '1,2' ], [ 'c', '2' ], [ 'a', '5' ] ]
    .map((pair)=>pair.map(decodeURIComponent))// [ [ 'a', '5' ], [ 'b, '1,2' ], [ 'c', '2' ] ]
    .sort((a, b)=>a[0].localeCompare(b[0]))// [ [ 'a', '5' ], [ 'b, '1%2C2' ], [ 'c', '2' ] ]
    .map((pair)=>pair.map(encodeURIComponent))// [ 'a=5', 'b=1%2C2', 'c=2' ]
    .map((pair)=>pair.join("="))// 'a=5&b=1%2C2&c=2'
    .join("&");
}

/**
 * Internal dependencies
 */ /**
 * Safely decodes a URI component with `decodeURIComponent`. Returns the URI component unmodified if
 * `decodeURIComponent` throws an error.
 *
 * @param {string} uriComponent URI component to decode.
 *
 * @return {string} Decoded URI component if possible.
 */ function $b1f7a5055b4ebc0b$export$1aa9ac0ef1c2d437(uriComponent) {
    try {
        return decodeURIComponent(uriComponent);
    } catch (uriComponentError) {
        return uriComponent;
    }
}


/**
 * Returns the query string part of the URL.
 *
 * @param {string} url The full URL.
 *
 * @example
 * ```js
 * const queryString = getQueryString( 'http://localhost:8080/this/is/a/test?query=true#fragment' ); // 'query=true'
 * ```
 *
 * @return {string|void} The query string part of the URL.
 */ function $16e049de0f483482$export$18380b9f669996bd(url) {
    let query;
    try {
        query = new URL(url, "http://example.com").search.substring(1);
    } catch (error) {}
    if (query) return query;
}


/** @typedef {import('./get-query-arg').QueryArgParsed} QueryArgParsed */ /**
 * @typedef {Record<string,QueryArgParsed>} QueryArgs
 */ /**
 * Sets a value in object deeply by a given array of path segments. Mutates the
 * object reference.
 *
 * @param {Record<string,*>} object Object in which to assign.
 * @param {string[]}         path   Path segment at which to set value.
 * @param {*}                value  Value to set.
 */ function $b0f17099efe4fe3d$var$setPath(object, path, value) {
    const length = path.length;
    const lastIndex = length - 1;
    for(let i = 0; i < length; i++){
        let key = path[i];
        if (!key && Array.isArray(object)) // If key is empty string and next value is array, derive key from
        // the current length of the array.
        key = object.length.toString();
        key = [
            "__proto__",
            "constructor",
            "prototype"
        ].includes(key) ? key.toUpperCase() : key;
        // If the next key in the path is numeric (or empty string), it will be
        // created as an array. Otherwise, it will be created as an object.
        const isNextKeyArrayIndex = !isNaN(Number(path[i + 1]));
        object[key] = i === lastIndex ? // If at end of path, assign the intended value.
        value : // Otherwise, advance to the next object in the path, creating
        // it if it does not yet exist.
        object[key] || (isNextKeyArrayIndex ? [] : {});
        if (Array.isArray(object[key]) && !isNextKeyArrayIndex) // If we current key is non-numeric, but the next value is an
        // array, coerce the value to an object.
        object[key] = {
            ...object[key]
        };
        // Update working reference object to the next in the path.
        object = object[key];
    }
}
function $b0f17099efe4fe3d$export$ae70ac52a8fdec95(url) {
    return ((0, $16e049de0f483482$export$18380b9f669996bd)(url) || "").replace(/\+/g, "%20").split("&").reduce((accumulator, keyValue)=>{
        const [key, value = ""] = keyValue.split("=")// Filtering avoids decoding as `undefined` for value, where
        // default is restored in destructuring assignment.
        .filter(Boolean).map((0, $b1f7a5055b4ebc0b$export$1aa9ac0ef1c2d437));
        if (key) {
            const segments = key.replace(/\]/g, "").split("[");
            $b0f17099efe4fe3d$var$setPath(accumulator, segments, value);
        }
        return accumulator;
    }, Object.create(null));
}

/**
 * Internal dependencies
 */ 
/**
 * Generates URL-encoded query string using input query data.
 *
 * It is intended to behave equivalent as PHP's `http_build_query`, configured
 * with encoding type PHP_QUERY_RFC3986 (spaces as `%20`).
 *
 * @example
 * ```js
 * const queryString = buildQueryString( {
 *    simple: 'is ok',
 *    arrays: [ 'are', 'fine', 'too' ],
 *    objects: {
 *       evenNested: {
 *          ok: 'yes',
 *       },
 *    },
 * } );
 * // "simple=is%20ok&arrays%5B0%5D=are&arrays%5B1%5D=fine&arrays%5B2%5D=too&objects%5BevenNested%5D%5Bok%5D=yes"
 * ```
 *
 * @param {Record<string,*>} data Data to encode.
 *
 * @return {string} Query string.
 */ function $65bba95dd071d14b$export$6b17a39e52c8ee53(data) {
    let string = "";
    const stack = Object.entries(data);
    let pair;
    while(pair = stack.shift()){
        let [key, value] = pair;
        // Support building deeply nested data, from array or object values.
        const hasNestedData = Array.isArray(value) || value && value.constructor === Object;
        if (hasNestedData) {
            // Push array or object values onto the stack as composed of their
            // original key and nested index or key, retaining order by a
            // combination of Array#reverse and Array#unshift onto the stack.
            const valuePairs = Object.entries(value).reverse();
            for (const [member, memberValue] of valuePairs)stack.unshift([
                `${key}[${member}]`,
                memberValue
            ]);
        } else if (value !== undefined) {
            // Null is treated as special case, equivalent to empty string.
            if (value === null) value = "";
            string += "&" + [
                key,
                value
            ].map(encodeURIComponent).join("=");
        }
    }
    // Loop will concatenate with leading `&`, but it's only expected for all
    // but the first query parameter. This strips the leading `&`, while still
    // accounting for the case that the string may in-fact be empty.
    return string.substr(1);
}


function $b18a10c10be3ae8b$export$c06457cd72751986(url = "", args) {
    // If no arguments are to be appended, return original URL.
    if (!args || !Object.keys(args).length) return url;
    let baseUrl = url;
    // Determine whether URL already had query arguments.
    const queryStringIndex = url.indexOf("?");
    if (queryStringIndex !== -1) {
        // Merge into existing query arguments.
        args = Object.assign((0, $b0f17099efe4fe3d$export$ae70ac52a8fdec95)(url), args);
        // Change working base URL to omit previous query arguments.
        baseUrl = baseUrl.substr(0, queryStringIndex);
    }
    return baseUrl + "?" + (0, $65bba95dd071d14b$export$6b17a39e52c8ee53)(args);
}


/**
 * @param {Record<string, any>} preloadedData
 * @return {import('../types').APIFetchMiddleware} Preloading middleware.
 */ function $0d04ac1a61440135$var$createPreloadingMiddleware(preloadedData) {
    const cache = Object.fromEntries(Object.entries(preloadedData).map(([path, data])=>[
            (0, $aa68ca4a6d2e4cac$export$6af368f973c74c5)(path),
            data
        ]));
    return (options, next)=>{
        const { parse: parse = true } = options;
        /** @type {string | void} */ let rawPath = options.path;
        if (!rawPath && options.url) {
            const { rest_route: pathFromQuery, ...queryArgs } = (0, $b0f17099efe4fe3d$export$ae70ac52a8fdec95)(options.url);
            if (typeof pathFromQuery === "string") rawPath = (0, $b18a10c10be3ae8b$export$c06457cd72751986)(pathFromQuery, queryArgs);
        }
        if (typeof rawPath !== "string") return next(options);
        const method = options.method || "GET";
        const path = (0, $aa68ca4a6d2e4cac$export$6af368f973c74c5)(rawPath);
        if ("GET" === method && cache[path]) {
            const cacheData = cache[path];
            // Unsetting the cache key ensures that the data is only used a single time.
            delete cache[path];
            return $0d04ac1a61440135$var$prepareResponse(cacheData, !!parse);
        } else if ("OPTIONS" === method && cache[method] && cache[method][path]) {
            const cacheData = cache[method][path];
            // Unsetting the cache key ensures that the data is only used a single time.
            delete cache[method][path];
            return $0d04ac1a61440135$var$prepareResponse(cacheData, !!parse);
        }
        return next(options);
    };
}
/**
 * This is a helper function that sends a success response.
 *
 * @param {Record<string, any>} responseData
 * @param {boolean}             parse
 * @return {Promise<any>} Promise with the response.
 */ function $0d04ac1a61440135$var$prepareResponse(responseData, parse) {
    return Promise.resolve(parse ? responseData.body : new window.Response(JSON.stringify(responseData.body), {
        status: 200,
        statusText: "OK",
        headers: responseData.headers
    }));
}
var $0d04ac1a61440135$export$2e2bcd8739ae039 = $0d04ac1a61440135$var$createPreloadingMiddleware;


/**
 * WordPress dependencies
 */ 

/**
 * Apply query arguments to both URL and Path, whichever is present.
 *
 * @param {import('../types').APIFetchOptions} props
 * @param {Record<string, string | number>}    queryArgs
 * @return {import('../types').APIFetchOptions} The request with the modified query args
 */ const $a6dea0ef37b77068$var$modifyQuery = ({ path: path, url: url, ...options }, queryArgs)=>({
        ...options,
        url: url && (0, $b18a10c10be3ae8b$export$c06457cd72751986)(url, queryArgs),
        path: path && (0, $b18a10c10be3ae8b$export$c06457cd72751986)(path, queryArgs)
    });
/**
 * Duplicates parsing functionality from apiFetch.
 *
 * @param {Response} response
 * @return {Promise<any>} Parsed response json.
 */ const $a6dea0ef37b77068$var$parseResponse = (response)=>response.json ? response.json() : Promise.reject(response);
/**
 * @param {string | null} linkHeader
 * @return {{ next?: string }} The parsed link header.
 */ const $a6dea0ef37b77068$var$parseLinkHeader = (linkHeader)=>{
    if (!linkHeader) return {};
    const match = linkHeader.match(/<([^>]+)>; rel="next"/);
    return match ? {
        next: match[1]
    } : {};
};
/**
 * @param {Response} response
 * @return {string | undefined} The next page URL.
 */ const $a6dea0ef37b77068$var$getNextPageUrl = (response)=>{
    const { next: next } = $a6dea0ef37b77068$var$parseLinkHeader(response.headers.get("link"));
    return next;
};
/**
 * @param {import('../types').APIFetchOptions} options
 * @return {boolean} True if the request contains an unbounded query.
 */ const $a6dea0ef37b77068$var$requestContainsUnboundedQuery = (options)=>{
    const pathIsUnbounded = !!options.path && options.path.indexOf("per_page=-1") !== -1;
    const urlIsUnbounded = !!options.url && options.url.indexOf("per_page=-1") !== -1;
    return pathIsUnbounded || urlIsUnbounded;
};
/**
 * The REST API enforces an upper limit on the per_page option. To handle large
 * collections, apiFetch consumers can pass `per_page=-1`; this middleware will
 * then recursively assemble a full response array from all available pages.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ const $a6dea0ef37b77068$var$fetchAllMiddleware = async (options, next)=>{
    if (options.parse === false) // If a consumer has opted out of parsing, do not apply middleware.
    return next(options);
    if (!$a6dea0ef37b77068$var$requestContainsUnboundedQuery(options)) // If neither url nor path is requesting all items, do not apply middleware.
    return next(options);
    // Retrieve requested page of results.
    const response = await (0, $f5e127342559a016$export$2e2bcd8739ae039)({
        ...$a6dea0ef37b77068$var$modifyQuery(options, {
            per_page: 100
        }),
        // Ensure headers are returned for page 1.
        parse: false
    });
    const results = await $a6dea0ef37b77068$var$parseResponse(response);
    if (!Array.isArray(results)) // We have no reliable way of merging non-array results.
    return results;
    let nextPage = $a6dea0ef37b77068$var$getNextPageUrl(response);
    if (!nextPage) // There are no further pages to request.
    return results;
    // Iteratively fetch all remaining pages until no "next" header is found.
    let mergedResults = /** @type {any[]} */ [].concat(results);
    while(nextPage){
        const nextResponse = await (0, $f5e127342559a016$export$2e2bcd8739ae039)({
            ...options,
            // Ensure the URL for the next page is used instead of any provided path.
            path: undefined,
            url: nextPage,
            // Ensure we still get headers so we can identify the next page.
            parse: false
        });
        const nextResults = await $a6dea0ef37b77068$var$parseResponse(nextResponse);
        mergedResults = mergedResults.concat(nextResults);
        nextPage = $a6dea0ef37b77068$var$getNextPageUrl(nextResponse);
    }
    return mergedResults;
};
var $a6dea0ef37b77068$export$2e2bcd8739ae039 = $a6dea0ef37b77068$var$fetchAllMiddleware;



/**
 * Set of HTTP methods which are eligible to be overridden.
 *
 * @type {Set<string>}
 */ const $e4e4284908f5ef5b$var$OVERRIDE_METHODS = new Set([
    "PATCH",
    "PUT",
    "DELETE"
]);
/**
 * Default request method.
 *
 * "A request has an associated method (a method). Unless stated otherwise it
 * is `GET`."
 *
 * @see  https://fetch.spec.whatwg.org/#requests
 *
 * @type {string}
 */ const $e4e4284908f5ef5b$var$DEFAULT_METHOD = "GET";
/**
 * API Fetch middleware which overrides the request method for HTTP v1
 * compatibility leveraging the REST API X-HTTP-Method-Override header.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ const $e4e4284908f5ef5b$var$httpV1Middleware = (options, next)=>{
    const { method: method = $e4e4284908f5ef5b$var$DEFAULT_METHOD } = options;
    if ($e4e4284908f5ef5b$var$OVERRIDE_METHODS.has(method.toUpperCase())) options = {
        ...options,
        headers: {
            ...options.headers,
            "X-HTTP-Method-Override": method,
            "Content-Type": "application/json"
        },
        method: "POST"
    };
    return next(options);
};
var $e4e4284908f5ef5b$export$2e2bcd8739ae039 = $e4e4284908f5ef5b$var$httpV1Middleware;


/**
 * WordPress dependencies
 */ /**
 * Internal dependencies
 */ /**
 * Internal dependencies
 */ 
function $12c7d726698d2487$export$75df27fc0a35b321(url, arg) {
    return (0, $b0f17099efe4fe3d$export$ae70ac52a8fdec95)(url)[arg];
}


function $653543242c949326$export$3c0fa5651fd37aa(url, arg) {
    return (0, $12c7d726698d2487$export$75df27fc0a35b321)(url, arg) !== undefined;
}


/**
 * @type {import('../types').APIFetchMiddleware}
 */ const $a7c0338a56198155$var$userLocaleMiddleware = (options, next)=>{
    if (typeof options.url === "string" && !(0, $653543242c949326$export$3c0fa5651fd37aa)(options.url, "_locale")) options.url = (0, $b18a10c10be3ae8b$export$c06457cd72751986)(options.url, {
        _locale: "user"
    });
    if (typeof options.path === "string" && !(0, $653543242c949326$export$3c0fa5651fd37aa)(options.path, "_locale")) options.path = (0, $b18a10c10be3ae8b$export$c06457cd72751986)(options.path, {
        _locale: "user"
    });
    return next(options);
};
var $a7c0338a56198155$export$2e2bcd8739ae039 = $a7c0338a56198155$var$userLocaleMiddleware;


/**
 * WordPress dependencies
 */ 
/**
 * WordPress dependencies
 */ 
/**
 * Parses the apiFetch response.
 *
 * @param {Response} response
 * @param {boolean}  shouldParseResponse
 *
 * @return {Promise<any> | null | Response} Parsed response.
 */ const $143b5c63e269aee7$var$parseResponse = (response, shouldParseResponse = true)=>{
    if (shouldParseResponse) {
        if (response.status === 204) return null;
        return response.json ? response.json() : Promise.reject(response);
    }
    return response;
};
/**
 * Calls the `json` function on the Response, throwing an error if the response
 * doesn't have a json function or if parsing the json itself fails.
 *
 * @param {Response} response
 * @return {Promise<any>} Parsed response.
 */ const $143b5c63e269aee7$var$parseJsonAndNormalizeError = (response)=>{
    const invalidJsonError = {
        code: "invalid_json",
        message: (0, $5b5c8d5cff038097$export$c6452175cea4361a)("The response is not a valid JSON response.")
    };
    if (!response || !response.json) throw invalidJsonError;
    return response.json().catch(()=>{
        throw invalidJsonError;
    });
};
const $143b5c63e269aee7$export$7f4dc73e58eeb853 = (response, shouldParseResponse = true)=>{
    return Promise.resolve($143b5c63e269aee7$var$parseResponse(response, shouldParseResponse)).catch((res)=>$143b5c63e269aee7$export$af91b101bc689703(res, shouldParseResponse));
};
function $143b5c63e269aee7$export$af91b101bc689703(response, shouldParseResponse = true) {
    if (!shouldParseResponse) throw response;
    return $143b5c63e269aee7$var$parseJsonAndNormalizeError(response).then((error)=>{
        const unknownError = {
            code: "unknown_error",
            message: (0, $5b5c8d5cff038097$export$c6452175cea4361a)("An unknown error occurred.")
        };
        throw error || unknownError;
    });
}


/**
 * @param {import('../types').APIFetchOptions} options
 * @return {boolean} True if the request is for media upload.
 */ function $dd1ef522eec4b375$var$isMediaUploadRequest(options) {
    const isCreateMethod = !!options.method && options.method === "POST";
    const isMediaEndpoint = !!options.path && options.path.indexOf("/wp/v2/media") !== -1 || !!options.url && options.url.indexOf("/wp/v2/media") !== -1;
    return isMediaEndpoint && isCreateMethod;
}
/**
 * Middleware handling media upload failures and retries.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ const $dd1ef522eec4b375$var$mediaUploadMiddleware = (options, next)=>{
    if (!$dd1ef522eec4b375$var$isMediaUploadRequest(options)) return next(options);
    let retries = 0;
    const maxRetries = 5;
    /**
   * @param {string} attachmentId
   * @return {Promise<any>} Processed post response.
   */ const postProcess = (attachmentId)=>{
        retries++;
        return next({
            path: `/wp/v2/media/${attachmentId}/post-process`,
            method: "POST",
            data: {
                action: "create-image-subsizes"
            },
            parse: false
        }).catch(()=>{
            if (retries < maxRetries) return postProcess(attachmentId);
            next({
                path: `/wp/v2/media/${attachmentId}?force=true`,
                method: "DELETE"
            });
            return Promise.reject();
        });
    };
    return next({
        ...options,
        parse: false
    }).catch((response)=>{
        const attachmentId = response.headers.get("x-wp-upload-attachment-id");
        if (response.status >= 500 && response.status < 600 && attachmentId) return postProcess(attachmentId).catch(()=>{
            if (options.parse !== false) return Promise.reject({
                code: "post_process",
                message: (0, $5b5c8d5cff038097$export$c6452175cea4361a)("Media upload failed. If this is a photo or a large image, please scale it down and try again.")
            });
            return Promise.reject(response);
        });
        return (0, $143b5c63e269aee7$export$af91b101bc689703)(response, options.parse);
    }).then((response)=>(0, $143b5c63e269aee7$export$7f4dc73e58eeb853)(response, options.parse));
};
var $dd1ef522eec4b375$export$2e2bcd8739ae039 = $dd1ef522eec4b375$var$mediaUploadMiddleware;


/**
 * WordPress dependencies
 */ 
/**
 * This appends a `wp_theme_preview` parameter to the REST API request URL if
 * the admin URL contains a `theme` GET parameter.
 *
 * @param {Record<string, any>} themePath
 * @return {import('../types').APIFetchMiddleware} Preloading middleware.
 */ const $f90e94c3b7f58f2c$var$createThemePreviewMiddleware = (themePath)=>(options, next)=>{
        if (typeof options.url === "string" && !(0, $653543242c949326$export$3c0fa5651fd37aa)(options.url, "wp_theme_preview")) options.url = (0, $b18a10c10be3ae8b$export$c06457cd72751986)(options.url, {
            wp_theme_preview: themePath
        });
        if (typeof options.path === "string" && !(0, $653543242c949326$export$3c0fa5651fd37aa)(options.path, "wp_theme_preview")) options.path = (0, $b18a10c10be3ae8b$export$c06457cd72751986)(options.path, {
            wp_theme_preview: themePath
        });
        return next(options);
    };
var $f90e94c3b7f58f2c$export$2e2bcd8739ae039 = $f90e94c3b7f58f2c$var$createThemePreviewMiddleware;



/**
 * Default set of header values which should be sent with every request unless
 * explicitly provided through apiFetch options.
 *
 * @type {Record<string, string>}
 */ const $f5e127342559a016$var$DEFAULT_HEADERS = {
    // The backend uses the Accept header as a condition for considering an
    // incoming request as a REST request.
    //
    // See: https://core.trac.wordpress.org/ticket/44534
    Accept: "application/json, */*;q=0.1"
};
/**
 * Default set of fetch option values which should be sent with every request
 * unless explicitly provided through apiFetch options.
 *
 * @type {Object}
 */ const $f5e127342559a016$var$DEFAULT_OPTIONS = {
    credentials: "include"
};
/** @typedef {import('./types').APIFetchMiddleware} APIFetchMiddleware */ /** @typedef {import('./types').APIFetchOptions} APIFetchOptions */ /**
 * @type {import('./types').APIFetchMiddleware[]}
 */ const $f5e127342559a016$var$middlewares = [
    (0, $a7c0338a56198155$export$2e2bcd8739ae039),
    (0, $2207936dc8e96153$export$2e2bcd8739ae039),
    (0, $e4e4284908f5ef5b$export$2e2bcd8739ae039),
    (0, $a6dea0ef37b77068$export$2e2bcd8739ae039)
];
/**
 * Register a middleware
 *
 * @param {import('./types').APIFetchMiddleware} middleware
 */ function $f5e127342559a016$var$registerMiddleware(middleware) {
    $f5e127342559a016$var$middlewares.unshift(middleware);
}
/**
 * Checks the status of a response, throwing the Response as an error if
 * it is outside the 200 range.
 *
 * @param {Response} response
 * @return {Response} The response if the status is in the 200 range.
 */ const $f5e127342559a016$var$checkStatus = (response)=>{
    if (response.status >= 200 && response.status < 300) return response;
    throw response;
};
/** @typedef {(options: import('./types').APIFetchOptions) => Promise<any>} FetchHandler*/ /**
 * @type {FetchHandler}
 */ const $f5e127342559a016$var$defaultFetchHandler = (nextOptions)=>{
    const { url: url, path: path, data: data, parse: parse = true, ...remainingOptions } = nextOptions;
    let { body: body, headers: headers } = nextOptions;
    // Merge explicitly-provided headers with default values.
    headers = {
        ...$f5e127342559a016$var$DEFAULT_HEADERS,
        ...headers
    };
    // The `data` property is a shorthand for sending a JSON body.
    if (data) {
        body = JSON.stringify(data);
        headers["Content-Type"] = "application/json";
    }
    const responsePromise = window.fetch(// Fall back to explicitly passing `window.location` which is the behavior if `undefined` is passed.
    url || path || window.location.href, {
        ...$f5e127342559a016$var$DEFAULT_OPTIONS,
        ...remainingOptions,
        body: body,
        headers: headers
    });
    return responsePromise.then((value)=>Promise.resolve(value).then($f5e127342559a016$var$checkStatus).catch((response)=>(0, $143b5c63e269aee7$export$af91b101bc689703)(response, parse)).then((response)=>(0, $143b5c63e269aee7$export$7f4dc73e58eeb853)(response, parse)), (err)=>{
        // Re-throw AbortError for the users to handle it themselves.
        if (err && err.name === "AbortError") throw err;
        // Otherwise, there is most likely no network connection.
        // Unfortunately the message might depend on the browser.
        throw {
            code: "fetch_error",
            message: (0, $5b5c8d5cff038097$export$c6452175cea4361a)("You are probably offline.")
        };
    });
};
/** @type {FetchHandler} */ let $f5e127342559a016$var$fetchHandler = $f5e127342559a016$var$defaultFetchHandler;
/**
 * Defines a custom fetch handler for making the requests that will override
 * the default one using window.fetch
 *
 * @param {FetchHandler} newFetchHandler The new fetch handler
 */ function $f5e127342559a016$var$setFetchHandler(newFetchHandler) {
    $f5e127342559a016$var$fetchHandler = newFetchHandler;
}
/**
 * @template T
 * @param {import('./types').APIFetchOptions} options
 * @return {Promise<T>} A promise representing the request processed via the registered middlewares.
 */ function $f5e127342559a016$var$apiFetch(options) {
    // creates a nested function chain that calls all middlewares and finally the `fetchHandler`,
    // converting `middlewares = [ m1, m2, m3 ]` into:
    // ```
    // opts1 => m1( opts1, opts2 => m2( opts2, opts3 => m3( opts3, fetchHandler ) ) );
    // ```
    const enhancedHandler = $f5e127342559a016$var$middlewares.reduceRight((/** @type {FetchHandler} */ next, middleware)=>{
        return (workingOptions)=>middleware(workingOptions, next);
    }, $f5e127342559a016$var$fetchHandler);
    return enhancedHandler(options).catch((error)=>{
        if (error.code !== "rest_cookie_invalid_nonce") return Promise.reject(error);
        // If the nonce is invalid, refresh it and try again.
        return window// @ts-ignore
        .fetch($f5e127342559a016$var$apiFetch.nonceEndpoint).then($f5e127342559a016$var$checkStatus).then((data)=>data.text()).then((text)=>{
            // @ts-ignore
            $f5e127342559a016$var$apiFetch.nonceMiddleware.nonce = text;
            return $f5e127342559a016$var$apiFetch(options);
        });
    });
}
$f5e127342559a016$var$apiFetch.use = $f5e127342559a016$var$registerMiddleware;
$f5e127342559a016$var$apiFetch.setFetchHandler = $f5e127342559a016$var$setFetchHandler;
$f5e127342559a016$var$apiFetch.createNonceMiddleware = (0, $f3a4c71ab038a960$export$2e2bcd8739ae039);
$f5e127342559a016$var$apiFetch.createPreloadingMiddleware = (0, $0d04ac1a61440135$export$2e2bcd8739ae039);
$f5e127342559a016$var$apiFetch.createRootURLMiddleware = (0, $2a5da459ef252cbd$export$2e2bcd8739ae039);
$f5e127342559a016$var$apiFetch.fetchAllMiddleware = (0, $a6dea0ef37b77068$export$2e2bcd8739ae039);
$f5e127342559a016$var$apiFetch.mediaUploadMiddleware = (0, $dd1ef522eec4b375$export$2e2bcd8739ae039);
$f5e127342559a016$var$apiFetch.createThemePreviewMiddleware = (0, $f90e94c3b7f58f2c$export$2e2bcd8739ae039);
var $f5e127342559a016$export$2e2bcd8739ae039 = $f5e127342559a016$var$apiFetch;


var $c9d61dbc78867beb$exports = {};
(function(global, factory) {
    $c9d61dbc78867beb$exports = factory();
})($c9d61dbc78867beb$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


function $f3bd859c172b26b1$var$isErrorWithMessage(error) {
    return typeof error === "object" && error !== null && "message" in error && typeof error.message === "string";
}
function $f3bd859c172b26b1$var$toErrorWithMessage(maybeError) {
    if ($f3bd859c172b26b1$var$isErrorWithMessage(maybeError)) return maybeError;
    try {
        return new Error(JSON.stringify(maybeError));
    } catch  {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError));
    }
}
function $f3bd859c172b26b1$export$82f46aa4e6535a45(error) {
    return $f3bd859c172b26b1$var$toErrorWithMessage(error).message;
}
function $f3bd859c172b26b1$export$32e6b1ae352e94d6(percent) {
    if (percent === 0) return "0%";
    else if (percent < 1) return "<1%";
    else return `${percent}%`;
}


const { restNonce: $9573f3897971ca07$var$restNonce, messages: $9573f3897971ca07$var$messages } = newsner_polls_data;
const $9573f3897971ca07$var$TRANSITION_DURATION = 100;
const $9573f3897971ca07$var$rootUrlMiddleware = (0, $f5e127342559a016$export$2e2bcd8739ae039).createRootURLMiddleware("/wp-json/");
const $9573f3897971ca07$var$nonceMiddleware = (0, $f5e127342559a016$export$2e2bcd8739ae039).createNonceMiddleware($9573f3897971ca07$var$restNonce);
(0, $f5e127342559a016$export$2e2bcd8739ae039).use($9573f3897971ca07$var$rootUrlMiddleware);
(0, $f5e127342559a016$export$2e2bcd8739ae039).use($9573f3897971ca07$var$nonceMiddleware);
/**
 * Initializes a form inside a container and adds a submit event listener to it.
 *
 * @param container - The container element that contains the form.
 * @param existingForms - A Set of existing forms to prevent adding duplicate event listeners.
 */ async function $9573f3897971ca07$var$initForm(container, existingForms) {
    const form = container.querySelector("form");
    if (form instanceof HTMLFormElement && !existingForms.has(form)) {
        form.addEventListener("submit", (e)=>$9573f3897971ca07$var$handleSubmit(e, container, form));
        existingForms.add(form);
    }
    $9573f3897971ca07$var$displayCookieMessage(container);
    const canVote = await $9573f3897971ca07$var$fetchAndUpdatePollVotes(container);
    if (!canVote) {
        form?.remove();
        $9573f3897971ca07$var$showResults(container);
    }
    gtag("event", "newsner_poll_viewed", {
        event_category: "poll",
        event_label: container.id
    });
    container.classList.remove("newsner-polls-pre-init");
}
function $9573f3897971ca07$var$fetchAndUpdatePollVotes(container) {
    return new Promise(async (resolve)=>{
        // prettier-ignore
        const pollIdBase64 = container.dataset?.poll;
        if (!pollIdBase64) return;
        try {
            const res = await (0, $f5e127342559a016$export$2e2bcd8739ae039)({
                path: `newsner-polls/v1/poll/${pollIdBase64}?block=${container.id}`
            });
            const results = container.querySelector(".results");
            const choices = container.querySelectorAll(".choice");
            $9573f3897971ca07$var$setTotalVotes(res.data.total, results, "no change");
            $9573f3897971ca07$var$setPercentData(choices, res.data.votes);
            $9573f3897971ca07$var$updateAllPercentBarWidths(res.data.total, container, "no change");
            resolve(res.data.can_vote);
        } catch (e) {
            console.error((0, $f3bd859c172b26b1$export$82f46aa4e6535a45)(e));
            $9573f3897971ca07$var$displayAlert(container, "error", $9573f3897971ca07$var$messages.general_error);
        }
        resolve(false);
    });
}
/**
 * Handles the form submission event.
 *
 * @param e - The submit event.
 * @param container - The HTML div element that contains the form.
 * @param form - The HTML form element.
 * @returns A Promise that resolves when the form submission is complete.
 */ async function $9573f3897971ca07$var$handleSubmit(e, container, form) {
    e.preventDefault();
    $9573f3897971ca07$var$removeAlerts(container);
    const formData = new FormData(form);
    if (e?.submitter instanceof HTMLButtonElement) formData.append("choice", e.submitter.value);
    formData.append("poll", container.dataset.poll ?? "");
    const data = Object.fromEntries(formData.entries());
    const choice = String(data.choice);
    const resetCount = $9573f3897971ca07$var$optimisticallyUpdateCount(choice, container);
    const removeSelectedChoice = $9573f3897971ca07$var$updateSelectedChoice(choice, container);
    try {
        const { success: success, message: message } = await (0, $f5e127342559a016$export$2e2bcd8739ae039)({
            path: "newsner-polls/v1/poll",
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        if (success) {
            console.info(message);
            gtag("event", "newsner_poll_submitted", {
                event_category: "poll",
                event_label: container.id,
                value: choice
            });
        } else throw new Error("Problem sending form");
    } catch (e) {
        const message = (0, $f3bd859c172b26b1$export$82f46aa4e6535a45)(e);
        console.error(message);
        $9573f3897971ca07$var$displayAlert(container, "error", $9573f3897971ca07$var$messages.general_error);
        resetCount();
        removeSelectedChoice();
    } finally{
        $9573f3897971ca07$var$showResults(container);
        $9573f3897971ca07$var$removeForm(form);
    }
}
/**
 * Initializes all poll forms in the document with the class "newsner-polls-block-container".
 *
 * @returns A function that can be called to re-initialize all poll forms.
 */ function $9573f3897971ca07$var$setupForms() {
    const existingForms = new Set([]);
    return ()=>{
        document.querySelectorAll(".newsner-polls-block-container").forEach((container)=>$9573f3897971ca07$var$initForm(container, existingForms));
    };
}
/**
 * Handles displaying an alert message in a container element.
 *
 * @param container - The container element to display the alert in.
 * @param type - The type of alert to display. Defaults to "success".
 * @param message - The message to display in the alert. Defaults to an empty string.
 */ function $9573f3897971ca07$var$displayAlert(container, type = "success", message = "") {
    const alert = container.querySelector(`.${type}`);
    const messageEl = alert?.querySelector(".message");
    if (messageEl instanceof HTMLDivElement) messageEl.textContent = message;
    if (alert instanceof HTMLDivElement) alert.classList.remove("np-hidden");
}
function $9573f3897971ca07$var$removeAlerts(container) {
    container.querySelectorAll(".np-alert").forEach((alert)=>alert.classList.add("np-hidden"));
}
function $9573f3897971ca07$var$removeForm(form) {
    setTimeout(()=>{
        form.remove();
    }, $9573f3897971ca07$var$TRANSITION_DURATION);
}
/**
 * Shows the poll results by removing the "np-hidden" class from the results container
 * and adding the "np-animate-grow-x" class to each percent bar.
 *
 * @param container - The HTMLDivElement that contains the poll results.
 */ function $9573f3897971ca07$var$showResults(container) {
    const results = container.querySelector(".results");
    const percentBars = container.querySelectorAll(".percent-bar");
    setTimeout(()=>{
        results?.classList.remove("np-hidden");
        percentBars.forEach((percentBar)=>{
            percentBar.classList.add("np-animate-grow-x");
        });
    }, $9573f3897971ca07$var$TRANSITION_DURATION);
}
/**
 * Updates the count of a choice in the UI optimistically.
 *
 * @param choice - The choice to update the count for.
 * @param container - The container element that holds the poll choices and results.
 * @returns A function that can be called to undo the optimistic update.
 */ function $9573f3897971ca07$var$optimisticallyUpdateCount(choice, container) {
    // if someone for some reason adds two or more choices with the same value
    // we need to update all of them in the UI
    const choiceElements = container.querySelectorAll(`[data-choice="${choice}"]`);
    const results = container.querySelector(".results");
    const totalVotes = Number(results?.dataset.votes);
    $9573f3897971ca07$var$updatePercentData(choiceElements, "add");
    $9573f3897971ca07$var$setTotalVotes(totalVotes, results, "add");
    $9573f3897971ca07$var$updateAllPercentBarWidths(totalVotes, container, "add");
    return ()=>{
        $9573f3897971ca07$var$updatePercentData(choiceElements, "subtract");
        $9573f3897971ca07$var$setTotalVotes(totalVotes, results, "subtract");
        $9573f3897971ca07$var$updateAllPercentBarWidths(totalVotes, container, "subtract");
    };
}
/**
 * Updates the percentage data for the given choice elements.
 *
 * @param choiceElements - The choice elements to update.
 * @param type - The type of update to perform. Defaults to "add".
 */ function $9573f3897971ca07$var$updatePercentData(choiceElements, type = "add") {
    choiceElements.forEach((choiceElement)=>{
        let currentCount = 0;
        const count = Number(choiceElement?.dataset?.count);
        if (type === "add") currentCount = count + 1;
        else if (type === "subtract") currentCount = count - 1;
        else currentCount = count;
        if (choiceElement?.dataset?.count) choiceElement.dataset.count = String(currentCount);
    });
}
/**
 * Updates the percentage data for the given choice elements.
 *
 * @param choiceElements - The choice elements to update.
 * @param type - The type of update to perform. Defaults to "add".
 */ function $9573f3897971ca07$var$setPercentData(choiceElements, votes) {
    choiceElements.forEach((choiceElement)=>{
        let currentCount = 0;
        currentCount = votes[choiceElement.dataset.choice ?? ""] ?? 0;
        if (choiceElement?.dataset?.count) choiceElement.dataset.count = String(currentCount);
    });
}
function $9573f3897971ca07$var$setTotalVotes(totalVotes, results, type = "add") {
    const newTotalVotes = $9573f3897971ca07$var$handleTotalVotesChange(type, totalVotes);
    if (results?.dataset?.votes) results.dataset.votes = String(newTotalVotes);
}
/**
 * Updates the width of all percent bars and count text elements in a poll container
 * based on the total number of votes and the type of update.
 *
 * @param totalVotes - The total number of votes in the poll.
 * @param container - The HTMLDivElement that contains the poll choices.
 * @param type - The type of update to perform. Defaults to "add".
 */ function $9573f3897971ca07$var$updateAllPercentBarWidths(totalVotes, container, type = "add") {
    const newTotalVotes = $9573f3897971ca07$var$handleTotalVotesChange(type, totalVotes);
    const choicesElements = container.querySelectorAll(".choice");
    choicesElements.forEach((choice)=>{
        const count = Number(choice?.dataset?.count);
        const countEl = choice.querySelector(".count");
        const percentBar = choice.querySelector(".percent-bar");
        if (countEl instanceof HTMLDivElement && percentBar instanceof HTMLDivElement) {
            const choicePercent = count / newTotalVotes * 100;
            const choicePercentRounded = Math.round(choicePercent * 10) / 10;
            percentBar.style.width = `${choicePercentRounded}%`;
            countEl.textContent = (0, $f3bd859c172b26b1$export$32e6b1ae352e94d6)(choicePercentRounded);
        }
    });
}
function $9573f3897971ca07$var$handleTotalVotesChange(type = "add", totalVotes) {
    switch(type){
        case "add":
            return totalVotes + 1;
        case "subtract":
            return totalVotes - 1;
        default:
            return totalVotes;
    }
}
/**
 * Updates the selected choice in the poll container by adding or removing the "np-font-bold"
 * class to the choice text element.
 *
 * @param choice - The choice to select.
 * @param container - The poll container element.
 * @returns A function that removes the "np-font-bold" class from the selected choice text element.
 */ function $9573f3897971ca07$var$updateSelectedChoice(choice, container) {
    const prevChoiceElements = container.querySelectorAll(".choice");
    prevChoiceElements.forEach((prevChoiceElement)=>{
        const text = prevChoiceElement.querySelector(".text");
        if (text instanceof HTMLDivElement) text.classList.remove("np-font-bold");
    });
    const choiceElements = container.querySelectorAll(`[data-choice="${choice}"]`);
    choiceElements.forEach((choiceElement)=>{
        const text = choiceElement.querySelector(".text");
        if (text instanceof HTMLDivElement) text.classList.add("np-font-bold");
    });
    return ()=>{
        choiceElements.forEach((choiceElement)=>{
            const text = choiceElement.querySelector(".text");
            if (text instanceof HTMLDivElement) text.classList.remove("np-font-bold");
        });
    };
}
function $9573f3897971ca07$var$displayCookieMessage(container) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c9d61dbc78867beb$exports))).get("_ga") === undefined) {
        container.querySelector("form")?.remove();
        $9573f3897971ca07$var$displayAlert(container, "error", $9573f3897971ca07$var$messages.allow_cookies);
        $9573f3897971ca07$var$showResults(container);
    }
}
window.addEventListener("DOMContentLoaded", ()=>{
    const initForms = $9573f3897971ca07$var$setupForms();
    initForms();
    // Listen for event for when content is added to .content_wrapper
    // This is needed to support infinite scroll
    document.addEventListener("content-added", initForms);
});

})();
//# sourceMappingURL=newsner-polls.js.map
